export default __webpack_public_path__ + "static/media/intro-1.28d0164e.png";